{
  "familyId": "MET-INH-CITER",
  "questions": [
    {
      "id": "MET-INH-CITER-001",
      "familyId": "MET-INH-CITER",
      "module": "Metriek",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "inhoud",
      "subSkill": "inh_kleine_maten",
      "questionType": "multiple_choice",
      "question": "Hoeveel centiliter (cl) is 2,5 liter?",
      "context": null,
      "options": ["250 cl", "25 cl", "2500 cl", "0,25 cl"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "stairs",
          "data": { "type": "volume", "from": "l", "to": "cl" }
        }
      ],
      "supportAids": [
        {
          "type": "stairs",
          "showWhen": "wrong",
          "data": { "type": "volume", "from": "l", "to": "cl", "value": 2.5, "highlight": true, "showAnimation": true }
        }
      ],
      "conceptId": "liter_to_centiliter",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Van liter naar centiliter ga je 2 treden naar beneden op het metrieke trapje. Elke trede is ×10, dus 2 treden = ×100. Berekening: 2,5 × 100 = 250 cl. Waarom ×100? Omdat er 100 centiliter in 1 liter gaan — 'centi' betekent honderdste. Check: 250 cl ÷ 100 = 2,5 l ✓",
        "solutionSteps": [
          "Bepaal het aantal treden: liter → deciliter → centiliter = 2 treden",
          "Elke trede naar beneden is ×10, dus 2 treden = ×100",
          "Vermenigvuldig: 2,5 × 100 = 250 cl",
          "Check: 250 ÷ 100 = 2,5 l ✓"
        ],
        "distractorExplanations": {
          "0": "Uitstekend! 2,5 liter × 100 = 250 centiliter. Je hebt het trapje goed gebruikt.",
          "1": "Je dacht waarschijnlijk dat je maar 1 trede naar beneden gaat (×10). Maar van liter naar centiliter zijn het 2 treden: liter → deciliter → centiliter. Dus ×100, niet ×10. Onthoud: 'centi' = honderdste.",
          "2": "Je dacht waarschijnlijk dat er 3 treden zijn (×1000). Maar van liter naar centiliter zijn het 2 treden (×100). 3 treden zou liter → milliliter zijn. Onthoud: l → cl = 2 treden, l → ml = 3 treden.",
          "3": "Je hebt gedeeld in plaats van vermenigvuldigd. Als je van een grote eenheid (liter) naar een kleine eenheid (centiliter) gaat, wordt het getal groter — dus vermenigvuldig je. Onthoud: groot → klein = ×."
        }
      }
    },
    {
      "id": "MET-INH-CITER-002",
      "familyId": "MET-INH-CITER",
      "module": "Metriek",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "inhoud",
      "subSkill": "inh_kleine_maten",
      "questionType": "multiple_choice",
      "question": "Een flesje bevat 33 cl. Hoeveel liter is dat?",
      "context": null,
      "options": ["330 liter", "3,3 liter", "0,33 liter", "0,033 liter"],
      "correctAnswer": 2,
      "stimulusAids": [
        {
          "type": "stairs",
          "data": { "type": "volume", "from": "cl", "to": "l" }
        }
      ],
      "supportAids": [
        {
          "type": "stairs",
          "showWhen": "wrong",
          "data": { "type": "volume", "from": "cl", "to": "l", "value": 33, "highlight": true, "showAnimation": true }
        }
      ],
      "conceptId": "centiliter_to_liter",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Van centiliter naar liter ga je 2 treden naar boven op het trapje. Elke trede is ÷10, dus 2 treden = ÷100. Berekening: 33 ÷ 100 = 0,33 liter. Waarom ÷100? Omdat 100 centiliter samen 1 liter vormen. Check: 0,33 × 100 = 33 cl ✓",
        "solutionSteps": [
          "Bepaal het aantal treden: centiliter → deciliter → liter = 2 treden",
          "Elke trede naar boven is ÷10, dus 2 treden = ÷100",
          "Deel: 33 ÷ 100 = 0,33 liter",
          "Check: 0,33 × 100 = 33 cl ✓"
        ],
        "distractorExplanations": {
          "0": "Je hebt vermenigvuldigd in plaats van gedeeld. Als je van een kleine eenheid (cl) naar een grote eenheid (l) gaat, wordt het getal kleiner — dus deel je. Onthoud: klein → groot = ÷.",
          "1": "Je dacht waarschijnlijk dat je maar 1 trede naar boven gaat (÷10). Maar van centiliter naar liter zijn het 2 treden (÷100). 33 ÷ 10 = 3,3 — dat klopt niet. Onthoud: cl → l = 2 treden.",
          "2": "Goed gedaan! 33 centiliter ÷ 100 = 0,33 liter.",
          "3": "Je dacht waarschijnlijk dat er 3 treden zijn (÷1000). Maar van centiliter naar liter zijn het 2 treden (÷100), niet 3. 3 treden zou milliliter → liter zijn. Onthoud: cl → l = ÷100."
        }
      }
    },
    {
      "id": "MET-INH-CITER-003",
      "familyId": "MET-INH-CITER",
      "module": "Metriek",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "inhoud",
      "subSkill": "inh_kleine_maten",
      "questionType": "multiple_choice",
      "question": "Een laborant heeft 4 deciliter vloeistof. Hoeveel centiliter is dat?",
      "context": "Een laborant in een ziekenhuis moet medicijnen nauwkeurig afmeten.",
      "options": ["400 cl", "40 cl", "4 cl", "0,4 cl"],
      "correctAnswer": 1,
      "stimulusAids": [
        {
          "type": "stairs",
          "data": { "type": "volume", "from": "dl", "to": "cl" }
        }
      ],
      "supportAids": [
        {
          "type": "stairs",
          "showWhen": "wrong",
          "data": { "type": "volume", "from": "dl", "to": "cl", "value": 4, "highlight": true, "showAnimation": true }
        }
      ],
      "conceptId": "deciliter_to_centiliter",
      "variantIndex": 3,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Van deciliter naar centiliter ga je 1 trede naar beneden op het trapje. Elke trede is ×10. Berekening: 4 × 10 = 40 cl. Waarom ×10? Omdat er 10 centiliter in 1 deciliter gaan — 'deci' is tiende, 'centi' is honderdste. Check: 40 cl ÷ 10 = 4 dl ✓",
        "solutionSteps": [
          "Bepaal het aantal treden: deciliter → centiliter = 1 trede",
          "1 trede naar beneden = ×10",
          "Vermenigvuldig: 4 × 10 = 40 cl",
          "Check: 40 ÷ 10 = 4 dl ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je 2 treden naar beneden gaat (×100). Maar van deciliter naar centiliter is het maar 1 trede (×10). 2 treden zou deciliter → milliliter zijn. Onthoud: dl → cl = 1 trede.",
          "1": "Goed! 4 deciliter × 10 = 40 centiliter.",
          "2": "Je dacht waarschijnlijk dat deciliter en centiliter dezelfde eenheid zijn. Maar 1 dl = 10 cl. 'Deci' = tiende, 'centi' = honderdste. Onthoud: dl is groter dan cl.",
          "3": "Je hebt gedeeld in plaats van vermenigvuldigd. Van een grotere eenheid (dl) naar een kleinere eenheid (cl) wordt het getal groter. Onthoud: groot → klein = ×."
        }
      }
    },
    {
      "id": "MET-INH-CITER-004",
      "familyId": "MET-INH-CITER",
      "module": "Metriek",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "inhoud",
      "subSkill": "inh_kleine_maten",
      "questionType": "multiple_choice",
      "question": "Een parfumflesje bevat 75 ml. Een apotheker wil dit omrekenen naar centiliter. Hoeveel centiliter is 75 ml?",
      "context": "Een apotheker rekent hoeveelheden om voor een recept.",
      "options": ["0,75 cl", "750 cl", "75 cl", "7,5 cl"],
      "correctAnswer": 3,
      "stimulusAids": [
        {
          "type": "stairs",
          "data": { "type": "volume", "from": "ml", "to": "cl" }
        }
      ],
      "supportAids": [
        {
          "type": "stairs",
          "showWhen": "wrong",
          "data": { "type": "volume", "from": "ml", "to": "cl", "value": 75, "highlight": true, "showAnimation": true }
        }
      ],
      "conceptId": "milliliter_to_centiliter",
      "variantIndex": 4,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Van milliliter naar centiliter ga je 1 trede naar boven op het trapje. Elke trede naar boven is ÷10. Berekening: 75 ÷ 10 = 7,5 cl. Waarom ÷10? Omdat er 10 milliliter in 1 centiliter gaan. Check: 7,5 × 10 = 75 ml ✓",
        "solutionSteps": [
          "Bepaal het aantal treden: milliliter → centiliter = 1 trede",
          "1 trede naar boven = ÷10",
          "Deel: 75 ÷ 10 = 7,5 cl",
          "Check: 7,5 × 10 = 75 ml ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je 2 treden naar boven gaat (÷100). Maar van milliliter naar centiliter is het maar 1 trede (÷10). 2 treden zou ml → dl zijn. Onthoud: ml → cl = 1 trede.",
          "1": "Je hebt vermenigvuldigd in plaats van gedeeld. Van een kleine eenheid (ml) naar een grotere eenheid (cl) wordt het getal kleiner — dus deel je. Onthoud: klein → groot = ÷.",
          "2": "Je dacht waarschijnlijk dat ml en cl dezelfde eenheid zijn. Maar 1 cl = 10 ml. Dus 75 ml = 7,5 cl, niet 75 cl. Onthoud: centiliter is groter dan milliliter.",
          "3": "Goed! 75 milliliter ÷ 10 = 7,5 centiliter."
        }
      }
    },
    {
      "id": "MET-INH-CITER-005",
      "familyId": "MET-INH-CITER",
      "module": "Metriek",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "inhoud",
      "subSkill": "inh_kleine_maten",
      "questionType": "fill_in",
      "question": "Een cocktailrecept vraagt om 1,5 dl sinaasappelsap. Hoeveel centiliter is dat? Typ je antwoord.",
      "context": "Een barista bereidt een cocktail volgens een recept.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["15", "15 cl", "15cl"],
        "caseSensitive": false,
        "placeholder": "? cl"
      },
      "stimulusAids": [
        {
          "type": "stairs",
          "data": { "type": "volume", "from": "dl", "to": "cl" }
        }
      ],
      "supportAids": [
        {
          "type": "stairs",
          "showWhen": "wrong",
          "data": { "type": "volume", "from": "dl", "to": "cl", "value": 1.5, "highlight": true, "showAnimation": true }
        }
      ],
      "conceptId": "deciliter_to_centiliter_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Van deciliter naar centiliter ga je 1 trede naar beneden: ×10. Berekening: 1,5 × 10 = 15 cl. Waarom ×10? Omdat er 10 centiliter in 1 deciliter gaan. Check: 15 cl ÷ 10 = 1,5 dl ✓",
        "solutionSteps": [
          "Bepaal de trede: deciliter → centiliter = 1 trede naar beneden",
          "1 trede = ×10",
          "Vermenigvuldig: 1,5 × 10 = 15 cl",
          "Check: 15 ÷ 10 = 1,5 dl ✓"
        ]
      }
    }
  ]
}